<template>
  <div>
    <MyModal :width="'50rem'" :height="'38rem'" :isOpen="isOpen" :toggleModal="toggleModal" :zIndex="200" :id="'product-modal'">
        <div v-if="selectedProduct.name" class="font-inter relative product-modal overflow-auto pb-4 md:pb-0" @scroll="handleModalScroll($event)">
          <div class="px-4 sticky flex items-center" style="z-index:50" id="product-title-nav">
            <button class="transition duration-200 hover:text-primary p-2 rounded-full box-shadow bg-white justify-self-start left-4" @click="toggleModal(!isOpen);setSelectedProduct({})">
              <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" style="fill: currentcolor;"></path></svg>
            </button>
            <h2 class="opacity-0 font-semibold left-1/2 -translate-x-1/2 absolute only-1-lines min-w-64 text-center">{{ selectedProduct.name }}</h2>
          </div>
          <div>
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12 md:col-span-5 w-full pl-8 overflow-auto max-h-full main-image-container relative">
                <img class="rounded-xl h-60 w-full object-contain main-product-image" :src="getProductImage(selectedProduct)" alt="Imagem do produto" srcset="" @error="($event.target as HTMLImageElement).src = '/assets/no-image.png'">
                <button class="absolute top-4 right-4 box-shadow p-2 rounded-lg" style="background:rgba(255, 255, 255, 0.8);z-index:201" @click="isAmplifyImageModalOpen = true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M21 9V3H15" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary" />
                    <path d="M3 15V21H9" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary" />
                    <path d="M21 3L13.5 10.5" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary" />
                    <path d="M10.5 13.5L3 21" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="stroke-primary" />
                  </svg>
                </button>
              </div>
              <div class="col-span-12 md:col-span-7 flex flex-col product-modal__right">
                <div class="px-4 pb-4">
                  <div class="flex items-center gap-2 mb-2">
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path d="M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 8V13" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M9 2H15" stroke="#171717" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg> -->
                    <!-- <p class="text-xs text-gray-500">Tempo de preparo <span class="text-primary font-bold">10 minutos</span></p> -->
                  </div>
                  <h5 class="text-xl font-bold" id="product-modal__product-name">{{ selectedProduct.name }}</h5>
                  <p class="text-gray-500 max-w-full mb-4 mt-2 text-sm">{{ displayDescription(selectedProduct.description as string) }} <button v-if="!knowMore && (selectedProduct.description?.length ?? 0) > 184" @click="knowMore = true" class="text-primary font-semibold uppercase underline">saiba mais</button></p>
                  <div v-if="selectedProduct.promotionalPrice && selectedProduct.promotionalPrice < selectedProduct.price" class="flex items-center gap-2">
                    <p class="font-bold text-sm"><span>De: </span><span class="line-through text-red-400">{{ selectedProduct.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span></p>
                  </div>
                  <div v-if="selectedProduct.promotionalPrice && selectedProduct.promotionalPrice < selectedProduct.price" class="font-bold flex items-center gap-2">
                    <p>
                      <span class="text-md">Por: </span> <span class="text-green-400 text-success">{{ selectedProduct.promotionalPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
                    </p>
                  </div>  
                  <p v-if="!selectedProduct.promotionalPrice || selectedProduct.promotionalPrice >= selectedProduct.price" class="font-bold text-neutral-700">{{ selectedProduct.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
                </div>
                <div class="product-modal__right__variation" v-for="(variation, variationIndex) in variantGroups" :key="variationIndex">
                  <div class="p-4 sticky top-0 z-20 product-modal__right__variation__header" style="background:#F9F9F9;">
                    <div class="flex justify-between items-center">
                      <h6 class="font-semibold">{{ variation.name }}</h6> 
                      <div class="relative" v-if="variation.required && variation.variants.filter((option: any) => option.selected).length >= (variation.minimumChoices || 1)">
                          <div class="h-4 w-4 bg rounded-full relative z-10 bg-success">
                              <svg viewBox="0 0 24 24" role="presentation" style="width: 1rem; height: 1rem;z-index:10"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" style="fill: #fff;"></path></svg>
                          </div>
                          <div class="absolute top-1/2 -translate-y-1/2 bg-success" style="width:100%;height:4px"></div>
                      </div>
                      <span v-else-if="variation.required" class="text-white font-bold bg-black p-2 py-1 rounded-lg text-xs">obrigatório</span>
                    </div>
                    <div class="flex items-center gap-2 pt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" style="min-width:16px" width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 8V12" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 16H12.01" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <p v-if="(variation.minimumChoices || (variation.required ? 1 : 0)) > 1 || variation.maximumChoices" class="text-xs text-gray-500">
                        <span v-if="(variation.minimumChoices || (variation.required ? 1 : 0)) > 1">mínimo {{ variation.minimumChoices || 1 }}</span>
                        <span v-if="(variation.minimumChoices || (variation.required ? 1 : 0)) > 1 && variation.maximumChoices"> e </span>
                        <span v-if="variation.maximumChoices">máximo {{ variation.maximumChoices }}</span> iten(s)
                      </p>
                      <p v-else-if="variation.required" class="text-xs text-gray-500">Selecione pelo menos uma opção</p>
                      <p v-else class="text-xs text-gray-500">Iten(s) opcionais</p>
                    </div>
                  </div>
                  <div class="grid grid-cols-12 gap-4 p-4">
                    <div 
                      @click="selectVariationOption(option, variationIndex)" 
                      style="height:6.5rem;background-position:center;background-size: cover;" :style="{backgroundImage:option.media?.length ? `url('${getProductImage(option, true)}')`:'unset'}" 
                      v-for="(option, optionIndex) in variation.variants" 
                      :key="optionIndex" 
                      class="relative cursor-pointer px-2 py-2 rounded-2xl font-bold transition-colors duration-200 w-full col-span-4 flex justify-center items-center flex-col gap-2 shadow-sm" 
                      :class="option.selected ? 'border-2 border-green-500':`${option.media?.length ? 'border-white border-2':'border lg:hover:border-2'} lg:hover:border-neutral-700`"
                    >
                      <div v-if="option.media?.length" class="absolute top-0 w-full h-full px-2 py-2 rounded-2xl left-0" style="background:rgb(0,0,0,0.2)"></div>
                      <span :class="option.media?.length ? 'text-white relative text-sm text-center drop-shadow-md':'text-center text-sm'">{{ option.name }}</span>
                      <div v-if="(option.price || 0) > 0" style="width:auto" class="px-2 text-sm h-5 bg-red-500 rounded-xl text-white text-[10px] flex justify-center items-center relative overflow-hidden whitespace-nowrap">+{{ (option.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}</div>
                    </div>
                  </div>
                </div>

                <div class="product-modal__addon-groups__addon-group" v-for="(addonGroup, addonGroupIndex) in selectedProduct.addOnGroups" :key="addonGroupIndex">
                  <div class="p-4 sticky top-0 product-modal__addon-groups__addon-group__header" style="background:#F9F9F9">
                    <div class="flex items-center justify-between gap-2">
                      <h6 class="font-semibold">
                        {{ addonGroup.name }}
                      </h6>
                      <span v-if="addonGroup.required && (addOnsQuantity[addonGroupIndex]?.totalQuantity ?? 0) < (addonGroup.minimumChoices || 1)" class="text-white font-bold bg-black p-2 py-1 rounded-lg text-xs">obrigatório</span>
                      <div class="relative" v-else-if="addonGroup.required">
                          <div class="h-4 w-4 bg rounded-full relative z-10 bg-success">
                              <svg viewBox="0 0 24 24" role="presentation" style="width: 1rem; height: 1rem;z-index:10"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" style="fill: #fff;"></path></svg>
                          </div>
                          <div class="absolute top-1/2 -translate-y-1/2 bg-success" style="width:100%;height:4px"></div>
                      </div>
                    </div>
                    <div class="flex items-center gap-2 pt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" style="min-width:16px" width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 8V12" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 16H12.01" stroke="#575757" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="flex items-center gap-2 justify-between w-full">
                        <p class="text-xs text-gray-500" v-if="(addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)) > 1 || addonGroup.maximumChoices">
                          <span v-if="(addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)) > 1">mínimo {{ addonGroup.minimumChoices || 1 }}</span>
                          <span v-if="(addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)) > 1 && addonGroup.maximumChoices"> e </span>
                          <span v-if="addonGroup.maximumChoices">máximo {{ addonGroup.maximumChoices }}</span> iten(s)
                        </p>
                        <p v-else-if="addonGroup.required" class="text-xs text-gray-500">Selecione pelo menos um item</p>
                        <p v-else class="text-xs text-gray-500">Iten(s) opcionais</p>
                        <span class="text-xs font-bold" v-if="addOnsQuantity[addonGroupIndex]?.totalQuantity && addonGroup.maximumChoices"><span class="text-success">{{ addOnsQuantity[addonGroupIndex]?.totalQuantity }}</span>/{{ addonGroup.maximumChoices }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col">
                    <div v-for="(addon, addonIndex) in addonGroup.addOns" :key="addonIndex" class="w-full flex items-center justify-between p-4 mt-1 pb-5" :class="addonIndex !== addonGroup.addOns.length - 1 ? 'border-b':''">
                      <div style="height:3rem" class="flex items-center gap-2">
                        <img class="rounded-lg object-cover" style="height:4rem;width:4rem" v-if="addon.media?.length" :src="getProductImage(addon, true)" alt="Imagem do complemento" @error="($event.target as HTMLImageElement).src = '/assets/no-image.png'">
                        <div>
                          <h6 class="lg:text-md text-sm">{{ addon.name }}</h6>
                          <span v-if="addon.price" class="text-white bg-green-500 text-[10px] rounded-xl px-2 py-0.5 font-semibold">+{{ addon.price.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                        </div>
                      </div>
                      <div class="flex gap-4 items-center text-sm py-2 rounded-lg pr-2" :class="addOnsQuantity[addonGroupIndex]?.addons[addon.id]?.quantity ? 'border px-2':''" style="transition:padding .2s">
                        <button v-if="addOnsQuantity[addonGroupIndex]?.addons[addon.id]?.quantity" 
                          class="transition duration-200 hover:text-green-500" 
                          @click="handleAddonsQuantity(addonGroupIndex, addon.id, -1)">
                            <svg viewBox="0 0 24 24" role="presentation" style="width: 1.2rem; height: 1.2rem;"><path d="M19,13H5V11H19V13Z" style="fill: currentcolor;"></path></svg>
                        </button>
                        {{ addOnsQuantity[addonGroupIndex]?.addons[addon.id]?.quantity ? addOnsQuantity[addonGroupIndex]?.addons[addon.id]?.quantity:'' }}
                        <button class="transition duration-200 hover:text-green-500" @click="handleAddonsQuantity(addonGroupIndex, addon.id, +1)">
                            <svg viewBox="0 0 24 24" role="presentation" style="width: 1.2rem; height: 1.2rem;"><path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" style="fill: currentcolor;"></path></svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <ProductInformation/> -->
              </div>
            </div>

            
          </div>
          <div v-if="!restaurant.restaurantConfig?.isDigitalCatalog" class="flex items-center gap-4 pt-4 fixed bottom-0 box-shadow sm:shadow-none sm:mt-5 right-0 left-0 rounded-tl-2xl rounded-tr-2xl sm:rounded-2xl justify-between px-8 py-4 product-modal__add-to-cart bg-white">
            <div class="flex gap-4 items-center">
                <button class="transition duration-200 hover:text-green-500" @click="quantity <= 1 ? '':quantity--">
                    <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,13H5V11H19V13Z" :style="{fill: quantity <= 1 ? '#ccc' : 'currentcolor'}"></path></svg>
                </button>
                <input type="text" class="w-3 text-center" :value="quantity" readonly/>
                <button class="transition duration-200 hover:text-green-500" @click="quantity++">
                    <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" style="fill: currentcolor;"></path></svg>
                </button>
            </div>
            <button :disabled="!canAddToCart || !areAddonGroupsRequirementsFulfilled" @click="addToCart" class="flex items-center justify-between p-3 md:p-4 rounded-2xl transition duration-200 font-inter" :style="{background: canAddToCart && areAddonGroupsRequirementsFulfilled ? restaurant.restaurantDesignCustom?.primaryColor ? restaurant.restaurantDesignCustom.primaryColor : '#323232' : '#f5f5f5', color: canAddToCart && areAddonGroupsRequirementsFulfilled ? 'var(--sf-on-primary, #fff)' : '#949494'}">
              <div>
                <p class="text-xs font-semibold">Adicionar ao carrinho</p>
                <p class="font-bold text-start font-bold">{{ totalPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}</p>
              </div>
              <svg viewBox="0 0 24 24" role="presentation" style="width: 1.8rem; height: 1.8rem;"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" :style="{fill: canAddToCart && areAddonGroupsRequirementsFulfilled ? '#fff' : '#949494'}"></path></svg>
            </button>
          </div>
        </div>
    </MyModal>

    <MyModal :width="'100%'" :height="'100%'" :className="''" :id="'amplify-image-modal'" :isOpen="isAmplifyImageModalOpen" :toggleModal="(v: any) => isAmplifyImageModalOpen = v" :zIndex="201">
      <div class="h-full" style="background:rgba(0,0,0,0.8)"> 
        <button class="transition duration-200 hover:text-primary p-2 rounded-full justify-self-start left-4 absolute top-3" @click="isAmplifyImageModalOpen = false;toggleModal(true)">
          <svg viewBox="0 0 24 24" role="presentation" style="width: 1.5rem; height: 1.5rem;"><path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" style="fill: #fff;"></path></svg>
        </button>
        <div class="flex justify-center items-center h-full flex flex-col gap-8">
          <img style="height:20rem" :src="getProductImage(selectedProduct)" alt="Imagem do produto" srcset="" @error="($event.target as HTMLImageElement).src = '/assets/no-image.png'">
          <div class="w-full flex flex-col md:items-center md:justify-center">
            <p class="text-white text-bold text-lg w-full text-start px-4">{{ selectedProduct.name }}</p>
            <p class="text-white text-semibold text-sm w-full text-start px-4 only-1-lines">{{selectedProduct.description}}</p>
          </div>
        </div>
      </div>
    </MyModal>
  </div>
</template>

<script lang="ts" setup>
import MyModal from './MyModal.vue';
import { ref, watch, computed } from 'vue';
import { cart, restaurant, getProductImage } from '@/global/state/GlobalState';
import { useToast } from "vue-toastification";
import { ProductModel } from '@/models/ProductModel';

// eslint-disable-next-line no-undef
/* global defineProps */
const props = defineProps<{
  selectedProduct: ProductModel, 
  toggleModal: Function, 
  isOpen: boolean, 
  setSelectedProduct: Function, 
  setSelectedProductVariations: Function
}>()

const quantity = ref<number>(1)
const addOnsQuantity = ref<any>({})
const canAddToCart = ref<boolean>(true)
const knowMore = ref<boolean>(false)
const isAmplifyImageModalOpen = ref<boolean>(false)
const toast = useToast()

const variantGroups = ref<any[]>([])

function displayDescription(description?: string){
  if(description && description?.length > 184){
    if(knowMore.value){
      return description
    }
    return description.substring(0, 164) + '...'
  }
  return description
}

function handleModalScroll(e: any){
  const productTitleNav = document.querySelector('#product-title-nav') as HTMLElement
  const modalProductTitle = document.querySelector('#product-modal__product-name') as HTMLElement
  if(productTitleNav && modalProductTitle){
      if(e.target.scrollTop >= modalProductTitle.offsetTop){
          productTitleNav.classList.add('show-title')
      } else{
          productTitleNav.classList.remove('show-title')
      }
  }
}

watch(() => props.selectedProduct, (newProduct: ProductModel) => {
    let values: any = {}
    knowMore.value = false
    
    if(newProduct.addOnGroups){
      newProduct.addOnGroups.forEach((addonGroup: any, index: number) => {
          if(!values[index]){
            values[index] = { totalQuantity: 0, name: addonGroup.name, addons: {} }
          }
          if(addonGroup.addOns) {
            addonGroup.addOns.forEach((addon: any) => {
              values[index].addons[addon.id] = { 
                name: addon.name, 
                quantity: 0, 
                price: addon.price, 
                id: addon.id 
              }
            })
          }
      })
      addOnsQuantity.value = values
    }

    if(newProduct.variantGroups){
      variantGroups.value = JSON.parse(JSON.stringify(newProduct.variantGroups)).map((variation: any) => {
        variation.variants = variation.variants.map((op: any) => {
          op.selected = false
          return op
        })
        return variation
      })
    } else {
      variantGroups.value = []
    }
    
    quantity.value = 1
}, { deep: false})

watch(() => variantGroups.value, (newProductVariations, oldProductVariations) => {
    let required: boolean[] = []
    let min: boolean[] = []
    let max: boolean[] = []
    let errorMessage = ''

    if(newProductVariations){
      newProductVariations.forEach((variation: any, index: number) => {
        let selectedOptions = variation.variants.filter((option: any) => option.selected)
        let oldSelectedOptions = oldProductVariations?.length === newProductVariations.length 
          ? oldProductVariations[index]?.variants.filter((option: any) => option.selected) || []
          : []

        if(variation.required){
          required.push(selectedOptions.length ? true : false)
        }

        const minChoices = variation.minimumChoices || (variation.required ? 1 : 0)
        if(selectedOptions.length < minChoices && oldSelectedOptions.length > selectedOptions.length){
            errorMessage = `Você precisa selecionar no mínimo ${minChoices} iten(s) em ${variation.name}`
        }
        min.push(selectedOptions.length >= minChoices)

        if(variation.maximumChoices && selectedOptions.length > variation.maximumChoices){
           errorMessage = `Você pode selecionar no máximo ${variation.maximumChoices} iten(s) em ${variation.name}`
        }
        max.push(!variation.maximumChoices || selectedOptions.length <= variation.maximumChoices)
      })

      canAddToCart.value = required.every((bool: boolean) => bool) && min.every((bool: boolean) => bool) && max.every((bool: boolean) => bool)

      if(!canAddToCart.value && errorMessage){
        toast.warning(errorMessage, {timeout: 2000})
      }
    }
}, { deep: true })

const areAddonGroupsRequirementsFulfilled = computed<boolean>(() => {
  if (!props.selectedProduct.addOnGroups) return true
  
  return props.selectedProduct.addOnGroups.every((addonGroup: any, index: number) => {
    const totalQty = addOnsQuantity.value[index]?.totalQuantity || 0
    const minChoices = addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)
    
    if (addonGroup.required) {
      return totalQty >= minChoices
    } else {
      if ((addonGroup.minimumChoices || 0) > 0 && totalQty > 0) {
        return totalQty >= addonGroup.minimumChoices
      }
      return true
    }
  })
})

const totalPrice = computed<number>(() => {
    let basePrice = props.selectedProduct.promotionalPrice && props.selectedProduct.promotionalPrice < props.selectedProduct.price 
      ? props.selectedProduct.promotionalPrice 
      : props.selectedProduct.price
    let total: number = quantity.value * basePrice

    for(let addonGroupIndex in addOnsQuantity.value){
      for(let addonId in addOnsQuantity.value[addonGroupIndex].addons){
        total += (addOnsQuantity.value[addonGroupIndex].addons[addonId].quantity * quantity.value) * parseFloat(addOnsQuantity.value[addonGroupIndex].addons[addonId].price || '0')
      }
    }

    variantGroups.value.forEach((variation: any) => {
        variation.variants.forEach((option: any) => {
            if(option.selected){
                total += (option.price || 0) * quantity.value;
            }
        })
    })

    return total
})

function handleAddonsQuantity(addonGroupIndex: any, id: any, value: any){
  const addonGroup = props.selectedProduct.addOnGroups?.[addonGroupIndex]
  if (!addonGroup) return

  const currentTotal = addOnsQuantity.value[addonGroupIndex].totalQuantity
  if (value > 0 && addonGroup.maximumChoices && currentTotal >= addonGroup.maximumChoices) {
    toast.warning(`Máximo de ${addonGroup.maximumChoices} itens atingido!`)
    return
  }
  
  if (value < 0 && addOnsQuantity.value[addonGroupIndex].addons[id].quantity <= 0) return

  addOnsQuantity.value[addonGroupIndex].addons[id].quantity += value
  addOnsQuantity.value[addonGroupIndex].totalQuantity += value
}

function selectVariationOption(option: any, variationIndex: number){
  const variation = variantGroups.value[variationIndex];
  
  if(variation.selectionType === 'single'){
    variation.variants.forEach((opt: any) => {
      if (opt !== option) opt.selected = false
    })
    option.selected = !option.selected
  } else {
    // Multiple selection
    if (!option.selected && variation.maximumChoices && variation.variants.filter((v: any) => v.selected).length >= variation.maximumChoices) {
      toast.warning(`Máximo de ${variation.maximumChoices} itens atingido!`)
      return
    }
    option.selected = !option.selected
  }
}

function addToCart(): void{
    const addonsQuantityFormated = Object.keys(addOnsQuantity.value)
    .filter((addonGroupIndex) => {
      return addOnsQuantity.value[addonGroupIndex].totalQuantity > 0;
    }).map((addonGroupIndex) => {
      let addonGroup = JSON.parse(JSON.stringify(addOnsQuantity.value[addonGroupIndex]))
      addonGroup.addons = Object.keys(addonGroup.addons)
        .filter((id: any) => addonGroup.addons[id].quantity > 0)
        .map((id: any) => addonGroup.addons[id])

      return {
        id: addonGroup.id,
        name: addonGroup.name,
        addons: addonGroup.addons
      }
    });

    if(canAddToCart.value && areAddonGroupsRequirementsFulfilled.value){
        let cartItems = JSON.parse(localStorage.getItem('cart') as string) ?? []
        
        let productVariations = variantGroups.value
          .filter((v: any) => v.variants.some((op: any) => op.selected))
          .map((v: any) => ({
            name: v.name,
            values: {
              label: v.variants.filter((op: any) => op.selected).map((op: any) => op.name),
              prices: v.variants.filter((op: any) => op.selected).map((op: any) => op.price || 0),
            ids: v.variants.filter((op: any) => op.selected).map((op: any) => op.id),
            groupId: v.id
          }
        }))

        const alreadyInCartIndex = cartItems.findIndex((item: any) => {
          return item.id === props.selectedProduct.id && 
                 item.variations === JSON.stringify(productVariations) &&
                 JSON.stringify(item.addon_groups) === JSON.stringify(addonsQuantityFormated)
        })

        if(alreadyInCartIndex !== -1){
          cartItems[alreadyInCartIndex].quantity += quantity.value
        } else {
            cartItems.push({
                ...props.selectedProduct,
                variations: JSON.stringify(productVariations),
                quantity: quantity.value, 
                addon_groups: addonsQuantityFormated, 
                organizationId: restaurant.value.id
            })
        }

        cart.value = cartItems
        localStorage.setItem('cart', JSON.stringify(cartItems))
        
        props.setSelectedProduct({})
        quantity.value = 1
        toast.success('Item adicionado ao carrinho!', {timeout:1500})
        props.toggleModal(false)
    }
}
</script>

<style lang="scss">
  #amplify-image-modal{
    transition:opacity .2s !important;
    border-radius:0 !important;
    background:transparent;
    img{
      height:35rem !important;
    }
    p{
      max-width:50rem
    }
  }
  @media screen and (min-width:800px){
    .product-modal{
      .main-product-image{
        width:100%;
        object-fit: fill;
      }
      #product-title-nav{
        margin-top:.5rem;
        button{
          box-shadow:unset
        }
      }
      &__right{
        height:26rem
      }
    }
  }

  @media screen and (max-width:800px){
    #amplify-image-modal{
      img{
        height:20rem !important;
      }
    }
    #product-title-nav{
      top:0;
      padding:0.5rem 1rem;
      transition:all .2s;
      width:100%;
  
      &.show-title{
        background:white;
        
        button{
          box-shadow:unset
        }
  
        h2{
          opacity:1
        }
      }
    } 

    .product-modal{
      padding-bottom:8rem !important;
      max-height:100%;
      .main-product-image{
        height:18rem;
        margin:auto;
        margin-top:0rem;
        width:25rem
      }
      &__add-to-cart{
        z-index:120
      }
    }

    .product-modal__right__variation__header{
      top:3.5rem;
    }

    .product-modal__addon-groups__addon-group__header{
      top:3.5rem;
    }
  }

  @media screen and (min-width:800px){
    .product-modal{
      &__right{
        overflow: auto;
      }

      &__add-to-cart{
        position:static
      }
    }
  }

  @media screen and (max-width:500px) {
    .product-modal{
      padding-top:0;
      #product-title-nav{
        position:fixed
      }
      .main-image-container{
        padding-left: 0;
        padding-right: 0;
      }
      .main-product-image{
        height:18rem;
        margin:auto;
        margin-top:2rem;
        width:100% !important;
        object-fit:fill;
        margin:unset !important;
        border-radius: unset;
      }
    }
  }
</style>